import { gql } from '@apollo/client';

export const SEARCH_CANDIDATES_BY_SEQUENCE_GROUP = gql`
	query searchWorkAssignmentCandidatesBySequenceGroup(
		$workAssignmentSequenceGroupId: ID!
		$fromStationId: ID!
		$toStationId: ID!
		$activityType: ActivityType!
		$searchFilter: CrewMemberSearchFilter!
	) {
		searchWorkAssignmentCandidates(
			workAssignmentSequenceGroupId: $workAssignmentSequenceGroupId
			fromStationId: $fromStationId
			toStationId: $toStationId
			activityType: $activityType
			searchFilter: $searchFilter
		) {
			crewMember {
				id
				fullName
				driverCard
				role
				isActive
				phone
				currentRun {
					name
				}
				currentJobs {
					code
				}
				currentEmploymentType {
					employmentType
				}
				lastWorkAssignment {
					activity {
						title
						rideId
					}
				}
				groups {
					name
				}
				currentHomeBase {
					city {
						name
						id
					}
				}
				holdDowns {
					id
					crewMember {
						id
						fullName
					}
					originalCrewMember {
						id
						fullName
						email
					}
					effectiveTimestamp
					expireTimestamp
					note
					createdAt
					updatedBy
				}
			}
			availabilityInfo {
				remainingCapacityMinutes
				nextAvailability
				idleTimeMinutes
				timeToFreshMinutes
				maxCapacityMinutes
				maxWorkingCapacityMinutes
				remainingWorkingCapacityMinutes
				isDestinationHomeBase
				isProtectionInDepartureLocation
			}
		}
	}
`;
